import React from 'react';

import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';

// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

import DataTable from '../../components/DataTable/DataTable';
import authInstance from '../../config/authInstance';
import { setLoading, setMessage } from '../../store/actions/general';


const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
});

async function changeEmail(email, password, onMessage, onLoading) {
  const token = localStorage.getItem('token');
  try {
    const response = await authInstance.post('/authentication/reset/email', { email, password }, {
      headers: { Authorization: ` Bearer ${token}` },
    });
    return (response.data && response.data.message) && onMessage(response.data.message);
  } catch (error) {
    onMessage(error);
  }
}
class UpdateAccountForm extends React.Component {
  state = {
    openModal: false,
    currentItem: {
      id: null,
      name: '',
      email: '',
      password: '',
    },
    currentAction: null,
    email: localStorage.getItem('email'),
  };


  handleActionClick = (action, item) => {
    if (item) {
      this.setState({ openModal: true, currentItem: item, currentAction: action });
    } else {
      this.setState({
        openModal: true,
        currentItem: { id: null, name: '' },
        currentAction: action,
      });
    }
  };

  handleActionCancel = () => {
    this.setState({ openModal: false });
  };

  handleActionConfirm = () => {
    changeEmail(
      this.state.currentItem.email,
      this.state.currentItem.password,
      this.props.onMessage,
      this.props.onLoading,
    );
    this.setState({ openModal: false });
  };


  handleChange = (event) => {
    this.setState({
      currentItem: { ...this.state.currentItem, name: event.target.value },
    });
  };

  handleChangeEmail = (event) => {
    this.setState({
      currentItem: { ...this.state.currentItem, email: event.target.value },
    });
  };
  handleChangePassword = (event) => {
    this.setState({
      currentItem: { ...this.state.currentItem, password: event.target.value },
    });
  };


  render() {
    // const { classes } = this.props;
    const { currentItem, currentAction } = this.state;
    const actions = [
      {
        name: 'Editar',
        icon: EditIcon,
        onClick: item => this.handleActionClick('Editar', item),
      },
    ];

    const rows = [{
      login: this.props.userName, email: this.state.email,
    },
    ];
    const columns = [{ name: 'login', label: 'Login' },
      { name: 'email', label: 'Email' }];


    return (
      <React.Fragment>
        <DataTable rows={rows} columns={columns} actions={actions} pagination={false} />
        <Dialog open={this.state.openModal} onClose={this.handleActionCancel}>
          <DialogTitle>{currentAction} Email</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Digite seu novo email e a senha para confirmação
              <form onSubmit={this.handleActionConfirm}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="email"
                  label="Email"
                  type="email"
                  onChange={this.handleChangeEmail}
                  value={currentItem.email}
                  fullWidth
                  required
                />
                <TextField
                  autoFocus
                  margin="dense"
                  name="password"
                  label="Senha"
                  type="password"
                  onChange={this.handleChangePassword}
                  value={currentItem.password}
                  fullWidth
                  required
                />
              </form>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleActionCancel}>CANCELAR</Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={this.handleActionConfirm}
              autoFocus={currentAction === 'Excluir'}
              disabled={!currentItem.password || !currentItem.email}
            >
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onMessage: message => dispatch(setMessage(message)),
  onLoading: loading => dispatch(setLoading(loading)),
});

const mapStateToProps = state => ({
  userName: state.auth.userName,
  email: state.auth.email,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UpdateAccountForm));
